import React from 'react';
import { Row, Col } from 'antd';
import { ImagesList } from './ImagesList';

export function Images() {
	return (
		<Row justify="start" gutter={[8, 8]}>
			<Col xs={24}>
				<ImagesList />
			</Col>
		</Row>
	);
}
